import {
  AnchorButton as BlueprintAnchorButton,
  AnchorButtonProps as BlueprintAnchorButtonProps,
} from '@blueprintjs/core';
import * as React from 'react';

import {
  Icon,
  IconComponentType,
  IconWrapperProps,
} from 'bones/design-system/components/icons/Icon';

export type ChipButtonProps = Pick<
  BlueprintAnchorButtonProps,
  'disabled' | 'onClick'
> & {
  'data-testid'?: never;
  icon: IconComponentType;
  iconProps?: Omit<IconWrapperProps, 'size'>;
  iconSize: IconWrapperProps['size'];
  testId?: string;
};

export const ChipButton: React.VFC<ChipButtonProps> = ({
  disabled,
  icon,
  iconSize,
  iconProps,
  testId,
  onClick,
}) => (
  <BlueprintAnchorButton
    className="vb-chip-button"
    data-testid={testId}
    disabled={disabled}
    onClick={onClick}
  >
    <Icon
      IconComponent={icon}
      size={iconSize}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...iconProps}
    />
  </BlueprintAnchorButton>
);
